<template lang="pug">
  breadcrumb(:itens="itens")
</template>

<script>
  import Breadcrumb from 'COMPONENTS/Breadcrumb'
  export default {
    props: ['itens'],
    components: {
      Breadcrumb
    }
  }
</script>



// WEBPACK FOOTER //
// Breadcrumb.vue?6cde25a6